import { NotificationKeys } from '../../../../../../../enums/notificationKeys'
import { DownloadFormat } from '../../../../../enums/downloadFormat'

export const getSalesReportDownloadNotificationId = (format: DownloadFormat): NotificationKeys => {
  const isFormatXlsx = format === DownloadFormat.xlsx
  const notificationId = isFormatXlsx
    ? NotificationKeys.SalesReportDownloadXlsx
    : NotificationKeys.SalesReportDownloadCsv

  return notificationId
}
